import type { AxiosResponse } from "axios";

const convert = <T>(response: AxiosResponse<T> | null | undefined): T => {
	try {
		if (!response || typeof response.data === "undefined") {
			console.error("Invalid AxiosResponse:", response);
			throw new Error("Invalid AxiosResponse");
		}
		return response.data as T;
	} catch (err) {
		console.log("Error in convert function", err);
		return null as T;
	}
};

const ConvertCount = ({ data }: AxiosResponse): number => data && parseInt(data.count, 10);

export default { convert, ConvertCount };
